import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator"]
  static values = { interval: { type: Number, default: 2000 } }

  connect() {
    this.index = 0
    this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    if (this.slideTargets.length < 2) return
    this.timer = setInterval(() => this.next(), this.intervalValue)
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  next() {
    this.show((this.index + 1) % this.slideTargets.length)
  }

  goTo(event) {
    this.stop()
    this.show(Number(event.currentTarget.dataset.galleryIndex))
  }

  show(index) {
    this.index = index

    this.slideTargets.forEach((slide, i) => {
      const active = i === index
      slide.classList.toggle("opacity-100", active)
      slide.classList.toggle("opacity-0", !active)
      slide.classList.toggle("pointer-events-none", !active)
      slide.setAttribute("aria-hidden", active ? "false" : "true")
    })

    this.indicatorTargets.forEach((indicator, i) => {
      const active = i === index
      indicator.classList.toggle("bg-white", active)
      indicator.classList.toggle("bg-white/40", !active)

      if (active) {
        indicator.setAttribute("aria-current", "true")
      } else {
        indicator.removeAttribute("aria-current")
      }
    })
  }
}
